import { api, type Api } from "@api/bot-base-api-request";
import { useQuery } from "@tanstack/react-query";

const BOT_GET_WALLETS_WITH_CHAIN_ID_QUERY_KEY = "bot-get-wallets-with-chain-id";

type BotGetWalletsWithChainIdParams = {
  appPubKey: string;
  userId: string;
  chainId: number;
};

type BotWalletsWithChainIdResponse = {
  wallets: string[];
};

const fetchBotWalletsWithChainId = async (
  api: Api,
  params: BotGetWalletsWithChainIdParams,
): Promise<BotWalletsWithChainIdResponse> =>
  api.get("wallets", { searchParams: params }).json();

const useGetBotWalletsWithChainId = (params: BotGetWalletsWithChainIdParams) =>
  useQuery<BotWalletsWithChainIdResponse>({
    queryKey: [BOT_GET_WALLETS_WITH_CHAIN_ID_QUERY_KEY, params],
    queryFn: async () => fetchBotWalletsWithChainId(api, params),
  });

export {
  useGetBotWalletsWithChainId,
  fetchBotWalletsWithChainId,
  BOT_GET_WALLETS_WITH_CHAIN_ID_QUERY_KEY,
};
